import * as React from 'react'

import styles from './CategoryHeader.module.scss'
import Image from '../UI/Image/Image'
import LinkComponent from '../UI/LinkComponent/LinkComponent'
import { getContentfulSrcSet } from 'src/utils/image'

type Props = {
  title: string
  description: string
  image: string
  background: string
  mainCat?: any
  mainLink?: string
}

const CategoryHeader = ({
  title,
  description,
  image,
  background,
  mainCat,
  mainLink,
}: Props) => (
    <div
      style={image ? {} : { background: background }}
      className={image ? styles.wrapper : [styles.wrapper, styles.low].join(' ')}
    >
      {image && (
        <Image
          className={styles.image}
          sizes="100vw"
          critical={true}
          srcSet={getContentfulSrcSet(image)}
          alt={title}
        />
      )}
      <div className={styles.categoryHeader}>
        <div className={styles.content}>
          {mainCat && (
            <LinkComponent className={styles.link} to={mainLink}>
              {mainCat.name}
            </LinkComponent>
          )}
          {title && <h1>{title}</h1>}
          {description && <p>{description}</p>}
        </div>
      </div>
    </div>
  )

export default CategoryHeader
